import * as React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase'

const Barcode = ({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 17 17' {...props}>
    <Path
      stroke={color}
      fill={fill}
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M4.5 3.5v10'
    />
    <Path
      stroke={color}
      fill={fill}
      strokeLinejoin='round'
      strokeWidth={0.5}
      d='M6.5 3.5v10M13.5 3.5v10M7.5 3.5v10'
    />
    <Path
      stroke={color}
      fill={fill}
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M9.5 3.5v10'
    />
    <Path stroke={color} fill={fill} strokeLinejoin='round' d='M12 3.5v10' />
    <Rect
      width={16.008}
      height={16.008}
      x={0.5}
      y={0.5}
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
      rx={1.778}
    />
  </IconBase>
)

Barcode.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Barcode
